module.exports = __webpack_public_path__ + "img/公安檢查人(設備類).3fa26608.jpg";